import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { cn } from "utils/cn";

export function SocialLinks({ socials, className, ...props }) {
    const [hoveredSocial, setHoveredSocial] = useState(null);
    const [rotation, setRotation] = useState(0);
    const [clicked, setClicked] = useState(false);

    const animation = {
        scale: clicked ? [1, 1.3, 1] : 1,
        transition: { duration: 0.3 },
    };

    useEffect(() => {
        const handleClick = () => {
            setClicked(true);
            setTimeout(() => {
                setClicked(false);
            }, 200);
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, [clicked]);

    return (
        <div
            className={cn("flex items-center justify-center gap-0", className)}
            {...props}
        >
            {socials.map((social, index) => (
                <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={cn(
                        "relative cursor-pointer px-5 py-2 transition-opacity duration-200",
                        hoveredSocial && hoveredSocial !== social.name
                            ? "opacity-50"
                            : "opacity-100"
                    )}
                    onMouseEnter={() => {
                        setHoveredSocial(social.name);
                        setRotation(Math.random() * 20 - 10);
                    }}
                    onMouseLeave={() => setHoveredSocial(null)}
                    onClick={() => {
                        setClicked(true);
                    }}
                >
                    <span className="block text-lg font-medium text-text-primary hover:text-primary transition-colors">{social.name}</span>
                    <AnimatePresence>
                        {hoveredSocial === social.name && (
                            <motion.div
                                className="absolute bottom-0 left-0 right-0 flex h-full w-full items-center justify-center pointer-events-none"
                                animate={animation}
                            >
                                <motion.img
                                    key={social.name}
                                    src={social.image}
                                    alt={social.name}
                                    className="w-16 h-16 object-contain"
                                    initial={{
                                        y: -40,
                                        rotate: rotation,
                                        opacity: 0,
                                        filter: "blur(2px)",
                                    }}
                                    animate={{ y: -50, opacity: 1, filter: "blur(0px)" }}
                                    exit={{ y: -40, opacity: 0, filter: "blur(2px)" }}
                                    transition={{ duration: 0.2 }}
                                />
                            </motion.div>
                        )}
                    </AnimatePresence>
                </a>
            ))}
        </div>
    );
}

const SocialFooter = () => {
    const socials = [
        {
            name: "LinkedIn",
            image: "https://upload.wikimedia.org/wikipedia/commons/8/81/LinkedIn_icon.svg",
            url: "https://www.linkedin.com/company/gradone"
        }
    ];

    return (
        <footer className="w-full py-10 bg-surface border-t border-border mt-auto">
            <div className="container mx-auto px-4 flex flex-col items-center justify-center">
                <SocialLinks socials={socials} />
                <p className="mt-6 text-sm text-muted-foreground">
                    © {new Date().getFullYear()} GradOne. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default SocialFooter;
